module.exports = __webpack_public_path__ + "img/image93.e0d48f3a.png";